@let foregroundNotification = this.foregroundNotification();
<div
  class="in-app-notification"
  role="status"
  aria-live="polite"
  aria-atomic="true"
  [class.show]="!!foregroundNotification"
  [class.md]="isAndroid()"
>
  <div
    role="button"
    class="notification-tap-area"
    [attr.aria-label]="foregroundNotification?.title"
    (click)="handleNotificationClick()"
  >
    <div class="left">
      <ion-icon src="/assets/icon/logo.svg" aria-hidden="true"></ion-icon>
      <div class="content">
        <span class="title">{{ foregroundNotification?.title }}</span>
        @if (foregroundNotification?.subtitle) {
          <span class="subtitle">{{ foregroundNotification?.subtitle }}</span>
        }
        <span class="subtitle">{{ foregroundNotification?.body }}</span>
      </div>
    </div>
    <div class="right">
      <span class="time-ago">{{ 'Common.Now' | translate }}</span>
    </div>
  </div>
  <ion-icon
    class="close-icon"
    name="close-outline"
    role="button"
    [attr.aria-label]="'Common.Dismiss' | translate"
    (click)="$event.stopPropagation(); clearNotification()"
  ></ion-icon>
</div>
